import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CalenderIcon,
  ChatIcon,
  GroupIcon,
  GridIcon,
} from "../icons";
import { vibrateTactile } from "../../helpers/vibrate";

const BOTTOM_NAV_HEIGHT = 72;
const BOTTOM_NAV_PADDING_BOTTOM = 12;

const navItems = [
  { name: "Agenda", path: "/appointments", icon: CalenderIcon },
  { name: "Conversas", path: "/conversations", icon: ChatIcon },
  { name: "Alunos", path: "/students", icon: GroupIcon },
  { name: "Dashboard", path: "/dashboard", icon: GridIcon },
];

export const BOTTOM_NAV_HEIGHT_PX = BOTTOM_NAV_HEIGHT;

const BottomNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (path: string) => {
    vibrateTactile();
    window.scrollTo({ top: 0, behavior: "auto" });
    document.querySelector("main")?.scrollTo({ top: 0, behavior: "auto" });
    navigate(path);
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 flex items-stretch justify-around md:hidden bg-white/95 dark:bg-gray-900/95 border-t border-gray-200/80 dark:border-gray-700/80 backdrop-blur-md shadow-[0_-4px_20px_-4px_rgba(0,0,0,0.08)] dark:shadow-[0_-4px_20px_-4px_rgba(0,0,0,0.3)]"
      style={{
        minHeight: BOTTOM_NAV_HEIGHT,
        paddingBottom: `max(${BOTTOM_NAV_PADDING_BOTTOM}px, env(safe-area-inset-bottom, 0px))`,
      }}
      onTouchStart={(e) => e.stopPropagation()}
      onTouchEnd={(e) => e.stopPropagation()}
    >
      {navItems.map((item) => {
        const isActive = location.pathname === item.path;
        const Icon = item.icon;
        return (
          <button
            key={item.path}
            type="button"
            onClick={() => handleNavClick(item.path)}
            className={`relative flex flex-col items-center justify-center gap-1 py-3 px-2 min-w-0 flex-1 min-h-[72px] transition-all duration-200 ease-out rounded-lg mx-0.5 active:scale-95 touch-manipulation cursor-pointer select-none ${
              isActive
                ? "text-brand-500"
                : "text-gray-500 active:bg-gray-100 dark:active:bg-gray-800 dark:text-gray-400 dark:active:text-gray-200"
            }`}
            aria-current={isActive ? "page" : undefined}
          >
            {isActive && (
              <span
                className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full bg-brand-500"
                aria-hidden
              />
            )}
            <span
              className={`flex items-center justify-center rounded-full p-1.5 transition-all duration-200 [&_svg]:h-6 [&_svg]:w-6 ${
                isActive
                  ? "bg-brand-500/15 dark:bg-brand-500/20 text-brand-500"
                  : ""
              }`}
            >
              <Icon />
            </span>
            <span
              className={`text-[11px] font-semibold truncate max-w-full leading-tight ${
                isActive
                  ? "text-brand-500"
                  : "text-gray-500 dark:text-gray-400"
              }`}
            >
              {item.name}
            </span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
